import React from 'react';
import SiteCharts from '../../../components/SiteCharts';
import { interFreqX1HoChartConfig } from '../chartConfigs';

/**
 * Props for the InterFreqX1HoEcharts component
 */
interface InterFreqX1HoEchartsProps {
  /** Callback function to toggle fullscreen mode */
  onFullscreenToggle: () => void;
  /** Current fullscreen state */
  isFullscreen: boolean;
}

/**
 * Inter-Frequency X2 Handover Success Rate Chart (LTE Site Level)
 * 
 * Displays inter-frequency handover metrics via X2 interface:
 * - Inter-Frequency X2 HO Success (count)
 * - Inter-Frequency X2 HO Attempt (count)
 * - Inter-Frequency X2 HO Success Rate (percentage)
 * 
 * @component
 * @see {@link ../chartConfigs.ts} - Chart configuration (interFreqX1HoChartConfig)
 * @see API: /api/lte/inter-freq-x2-ho?site_name={siteName}
 */

const InterFreqX1HoEcharts: React.FC<InterFreqX1HoEchartsProps> = ({ 
  onFullscreenToggle, 
  isFullscreen 
}) => {
  return (
    <SiteCharts 
      config={interFreqX1HoChartConfig}
      onFullscreenToggle={onFullscreenToggle}
      isFullscreen={isFullscreen}
    />
  );
};

export default InterFreqX1HoEcharts;
